import React, { Component } from 'react';
import { connect } from "react-redux";
import { Button,Tabs,Tab,Nav} from 'react-bootstrap';
import * as actionCreator from "../../action/index.js";
import {commonConfirmationAlert,handleCloseforDoorWindows,showCenterBuilding,ShowHideTranslusant} from "../../action/index.js";
import {captureBlobImages} from "../../action/extra_options/orderExtras.action.js";
import * as cuComponent from '../../redux/reducers/building_component/componentReducer.js';
import { params } from '../../redux/reducers/reducer.js';


class ShowFullBuilding extends Component {

  CheckCaptureImage = ()=>{
    this.props.handleCloseforDoorWindows(1);
    this.props.captureBlobImages();
}


  render() {
   

 let SelectedData = "centerBuilding";
  if(this.props.const_var.llsh==true && this.props.const_var.rlsh==true && this.props.const_var.flsh==true && this.props.const_var.blsh==true  )
  {
    SelectedData = "centerBuilding";
  } else if (this.props.const_var.llsh==true)
  {
    SelectedData = "centerBuilding";
  }else if(this.props.const_var.rlsh==true)
  {
    SelectedData = "centerBuilding";
  }else if(this.props.const_var.flsh==true)
  {
    SelectedData = "centerBuilding";
  }else if(this.props.const_var.blsh==true)
  {
    SelectedData = "centerBuilding";
  }else
  {
    SelectedData = "fullBuilding";
  }
    return(
      <>
      {(this.props.params.ShowLeanRecord==true)?
         <div className="newleancheckbox-wrapper d-none">
          <Tab.Container defaultActiveKey={SelectedData}>
                <Nav variant="pills justify-content-center ">
                    <Nav.Item>
                      <Nav.Link active={SelectedData == "centerBuilding"?true:false}  eventKey="centerBuilding" onClick={(e) => this.props.ChangeBackgroundAccordingtoCon("Center")} >
                        Center Building
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link active={SelectedData == "fullBuilding"?true:false}  eventKey="fullBuilding" onClick={(e) => this.props.ChangeBackgroundAccordingtoCon("Full")}>                
                         Full Building
                      </Nav.Link>
                    </Nav.Item>
                </Nav>
          </Tab.Container>
        </div>:null
    }
    
    <div className='center-frame-wrapper'>
        {/* for center building toggle start  */}
        { (this.props.params.ShowLeanRecord==true && this.props.selectedTabKey != 'extraoptions')?
            <div className="newleancheckbox-wrapper  togglelabel cursor-pointer">
                <div className={(params.isShowCenter == true)?'toggle-item  active':'toggle-item '} >
                  <span>View Center Building</span> <span className=''>
                     <input type="checkbox" id="toggly2" />
                     {/* please keep the showCenterBuilding handeler on lablel tag not in div tag  */}
                      <label  onClick={() => this.props.showCenterBuilding()} for="toggly2"   className="cursor-pointer"><i></i></label>
                  </span>
                </div>
           </div>
        :null
       }
      {/* capture cta start */}
      {/*<div className="newleancheckbox-wrapper togglelabel capture-cta cursor-pointer d-lg-none" 
        onClick={e => (this.props.const_var.i_g_A_y.length>4)? this.props.commonConfirmationAlert('captuareIMG'):this.CheckCaptureImage()}>
          <span className="icon-shutter icon"></span> <span className="text ml-1">Capture</span>
      </div>*/}
      {/* capture cta end */}
    </div>
    </>
)
  }
}

const mapStateToProps = (state) => {
  return state.reducer
}
const mapDispatchToProps = {
  handleCloseforDoorWindows,
  captureBlobImages,
  commonConfirmationAlert,
  ShowHideTranslusant,
  showCenterBuilding
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShowFullBuilding);

